export const display = {
    title: 'Display',
    titleEN: 'Display',
    description: 'Yemek.com\'da kullanılan display reklamları ve banner örnekleri',
    descriptionEN: 'Display ads and banner examples used on Yemek.com',
    tabs: [
        {
            id: 1,
            title: 'Display',
            sliderPerView: 2,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/85d6bd6b45efa2f3410f7c29e35afdd03943df6bb51407aecca28c6d80f5d2db.png',
                    category: 'Superfresh PS',
                    modal: 'image'
                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/11ef099fdfccc5d61a2fe83dc2664cfc8b327b6324715e21440e3bba7f4a2682.png',
                    category: 'QNB Masthead',
                    modal: 'image'

                }
            ]
        }
    ],
    egTabs: [
        {
            id: 1,
            title: 'Display',
            sliderPerView: 2,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/85d6bd6b45efa2f3410f7c29e35afdd03943df6bb51407aecca28c6d80f5d2db.png',
                    category: 'Superfresh PS',
                    modal: 'image'

                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/11ef099fdfccc5d61a2fe83dc2664cfc8b327b6324715e21440e3bba7f4a2682.png',
                    category: 'QNB Masthead',
                    modal: 'image'

                }
            ]
        }
    ]
} 